import { theme } from 'shared';
export default theme;
